import { cn } from '@/lib/utils'
import { getScentFamilyColor } from '@/data/scentFamilies'
import type { ScentFamily } from '@/types'

interface ScentFamilyBadgeProps {
  family: ScentFamily
  className?: string
}

export function ScentFamilyBadge({ family, className }: ScentFamilyBadgeProps) {
  return (
    <span
      className={cn(
        'font-condensed text-xs uppercase tracking-[0.15em] text-carbon/70',
        className
      )}
    >
      <span
        className="mr-2 inline-block h-1.5 w-1.5 rounded-full"
        style={{ backgroundColor: getScentFamilyColor(family) }}
        aria-hidden="true"
      />
      {family}
    </span>
  )
}
